module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-header-icon-wrapper"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.icon,
      "img-src": _vm.iconSrc,
      "size": _vm.iconSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-161d539f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/common/rtHeaderIcon.vue
// module id = 1461
// module chunks = 91